// extracted by mini-css-extract-plugin
export default {"geoMap":"GeoZonesMapWidget_geoMap__bRRSm"};